// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_UpdateOrigemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/origens/updateOrigem
 *
 * Updates an existing origin (origem de orcamento).
 */
import { registerContract } from './validate'

export interface Origens_UpdateOrigemInput {
origem_id: number
origem_nome?: string
origem_franquia_id?: number
}

registerContract('Origens_UpdateOrigemInput', {
  origem_id:          { type: 'number',  required: true },
  origem_nome:        { type: 'string',  required: false },
  origem_franquia_id: { type: 'number',  required: false },
})
